import React from "react"
import Header from "./component/Header/Header"
import Skills from "./component/Skills/Skills"
import Home from "./component/Home/Home"
import Portfolio from "./component/Portfolio/Portfolio";
import Contact from "./component/Contact/Contact"
import Footer from "./component/Footer"
import './App.css';

const App = () => {
  return (
    <>
      <Header />
      <Home />
      <Skills />
      <Portfolio />
      <Contact />
      <Footer />
    </>
  )
}

export default App
